// react
import React from "react";
// components
import { Icon } from "semantic-ui-react";

// component
function ActivityFormLabel({ icon, text, required }) {
    // template
    return (
        <div style={{ marginBottom: "1rem" }}>
            <label>
                {icon && <Icon name={icon} />}
                <strong>
                    {text}{" "}
                    {required ? <sup style={{ color: "red" }}>*</sup> : <></>}
                </strong>
            </label>
        </div>
    );
}

export default ActivityFormLabel;
